import React, { useEffect, useState } from 'react';
import { useInView } from './ui';
const DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

/**
 * Rolling odometer numeral. Each digit is a vertical 0-9 strip that
 * translates into place when the element enters the viewport.
 * Non-digit characters (commas, %, +, x, .) render as static glyphs.
 */
export function Odometer({
  value,
  className = '',
  delayStep = 90,
  duration = 1.7
}: {
  value: string;
  className?: string;
  delayStep?: number;
  duration?: number;
}) {
  const {
    ref,
    inView
  } = useInView<HTMLSpanElement>(0.4);
  const [go, setGo] = useState(false);
  useEffect(() => {
    if (!inView) return;
    const t = setTimeout(() => setGo(true), 60);
    return () => clearTimeout(t);
  }, [inView]);
  return <span ref={ref} className={`inline-flex align-baseline ${className}`} style={{
    lineHeight: 1
  }} aria-label={value} data-id="element-118">
      {value.split('').map((ch, i) => /\d/.test(ch) ? <span key={i} className="inline-block overflow-hidden" style={{
      height: '1em'
    }} aria-hidden="true" data-id="element-119">
            <span className="inline-flex flex-col will-change-transform" style={{
        transform: go ? `translateY(-${Number(ch)}em)` : 'translateY(0em)',
        transition: `transform ${duration}s cubic-bezier(0.16, 1, 0.3, 1) ${i * delayStep}ms`
      }} data-id="element-120">
              {DIGITS.map(d => <span key={d} style={{
          height: '1em',
          lineHeight: 1
        }} data-id="element-121">
                  {d}
                </span>)}
            </span>
          </span> : <span key={i} style={{
      height: '1em',
      lineHeight: 1
    }} aria-hidden="true" data-id="element-122">
            {ch}
          </span>)}
    </span>;
}